import script from "./PaymentQRCodeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentQRCodeCard.vue?vue&type=script&setup=true&lang=js"

import "./PaymentQRCodeCard.vue?vue&type=style&index=0&id=a4274bec&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4274bec"]])

export default __exports__